
import {
  computed, defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SelecionarSimNao',
  components: {
  },
  props: {
    valor: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
    classCss: {
      type: String,
      default: '',
    },
    dataAttributeColuna: {
      type: String,
      default: '',
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: boolean) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:boolean) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:boolean) {
      emit('change', valor);
    }

    return {
      props,
      computedValor,
      defineValorSelecionado,
      defineValorMarcado,
    };
  },
});
